import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import EngravingInput from '../engraving-input'
import {Box, Text, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../utils/cloudinary-utils'

const LineOne = (props) => {
    const {
        setVisibleLine,
        visibleLine,
        showInitialSpinner,
        shouldShowLineToggle,
        engravingLines,
        selectedFace,
        maxLength,
        product,
        setShowFonts,
        selectedHeading,
        setSelectedHeading,
        displayIconType,
        setDisplayIconType,
        restrictionListArray,
        handleLineChange,
        selectedFont
    } = props
    return (
        <Box className="line-1-box">
            <Box
                mt="30px"
                textAlign="right"
                onClick={() => {
                    setVisibleLine(visibleLine === 'line1' ? '' : 'line1')
                }}
                display={!showInitialSpinner && shouldShowLineToggle ? 'flex' : 'none'}
                alignItems="center"
                cursor="pointer"
                justifyContent="space-between"
            >
                <Box gap="15px" display="inline-flex">
                    <Text
                        color="teal.500"
                        fontSize="16px"
                        fontWeight="400"
                        letterSpacing="0.08px"
                        lineHeight="25px"
                    >
                        <FormattedMessage id="line1" defaultMessage="Line 1" />
                    </Text>
                    {engravingLines?.[selectedFace]?.line1 && (
                        <Text
                            color="black.100"
                            fontSize="16px"
                            fontFamily="ksSansSerif"
                            fontWeight="300"
                            letterSpacing="0.08px"
                            marginTop="2px"
                            lineHeight="25px"
                        >
                            {engravingLines?.[selectedFace]?.line1
                                ?.replaceAll('{{#font=kendra-characters-24-01-22.ttf}}', '')
                                ?.replaceAll('{{/}}', '')}
                        </Text>
                    )}
                </Box>
                <Box display="flex" alignItems="center" gap="10px">
                    <Text
                        display={visibleLine === 'line1' ? 'none' : 'block'}
                        fontSize="13px"
                        fontWeight="300"
                        textDecoration="underline"
                        textUnderlineOffset="4px"
                        color="black.300"
                        lineHeight="22px"
                    >
                        {engravingLines?.[selectedFace]?.line1 ? (
                            <FormattedMessage id="edit.free.engraving" defaultMessage="Edit" />
                        ) : (
                            <FormattedMessage id="engraving.add.line" defaultMessage="Add a Line" />
                        )}
                    </Text>
                    <Image
                        width="15px"
                        height="15px"
                        alt="arrow"
                        transform={visibleLine === 'line1' ? 'rotate(-90deg)' : 'rotate(90deg)'}
                        src={getUrl('UIImages/images/redesign/arrow-default.svg')}
                    />
                </Box>
            </Box>
            <Box
                className={`engraving-first-line-wrapper ${visibleLine === 'line1' ? 'show' : ''}`}
                mt="0px"
                display={showInitialSpinner ? 'none' : 'block'}
                data-selected-face={selectedFace}
            >
                <Box
                    display={{base: 'none', md: 'block'}}
                    marginTop={shouldShowLineToggle ? '20px' : '30px'}
                >
                    <Text color="gray.800" fontSize="13" fontWeight="400">
                        <FormattedMessage
                            id="engraving.type.initials"
                            defaultMessage="Type in initials or add a symbol. You can even combine them."
                        />
                    </Text>
                    <Text color="gray.800" fontSize="13" fontWeight="300" marginTop="5px">
                        {maxLength === 1 && (
                            <FormattedMessage
                                id="engraving.one.length.available"
                                defaultMessage="This piece has a max of 1 character(s)."
                            />
                        )}
                    </Text>
                </Box>
                <EngravingInput
                    id="engraving-first-line"
                    product={product}
                    setShowFonts={setShowFonts}
                    selectedHeading={selectedHeading}
                    setSelectedHeading={setSelectedHeading}
                    displayIconType={displayIconType}
                    setDisplayIconType={(val) => {
                        setDisplayIconType(val)
                    }}
                    restrictionListArray={restrictionListArray}
                    maxLength={maxLength}
                    showInitialSpinner={showInitialSpinner}
                    value={engravingLines[selectedFace]?.line1}
                    handleLineChange={(value) => {
                        handleLineChange(value, 'line1')
                    }}
                    selectedFaceLines={engravingLines[selectedFace]}
                    selectedFont={selectedFont[selectedFace]}
                />
            </Box>
        </Box>
    )
}

LineOne.propTypes = {
    setVisibleLine: PropTypes.func,
    visibleLine: PropTypes.number,
    showInitialSpinner: PropTypes.bool,
    shouldShowLineToggle: PropTypes.bool,
    engravingLines: PropTypes.any,
    selectedFace: PropTypes.string,
    maxLength: PropTypes.number,
    product: PropTypes.object,
    setShowFonts: PropTypes.func,
    selectedHeading: PropTypes.string,
    setSelectedHeading: PropTypes.func,
    displayIconType: PropTypes.string,
    setDisplayIconType: PropTypes.func,
    restrictionListArray: PropTypes.array,
    handleLineChange: PropTypes.func,
    selectedFont: PropTypes.string
}

export default LineOne
